export const DEVELOPER_ARTICLE_CATEGORIES = [
  'Updates',
  'Releases',
  'New Features',
  'Application Notes',
  'Technical Blog',
]

export const CONTACT_FORM_URL = 'https://forms.cloud.microsoft/e/uJq8YKUs4J'
